module.exports = __webpack_public_path__ + "static/media/instagramclone-gif.3fde5d46.gif";